import { render, staticRenderFns } from "./GiantGemPkg.vue?vue&type=template&id=0608c5a2&"
import script from "./GiantGemPkg.vue?vue&type=script&lang=js&"
export * from "./GiantGemPkg.vue?vue&type=script&lang=js&"
import style0 from "./GiantGemPkg.vue?vue&type=style&index=0&id=0608c5a2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0608c5a2')) {
      api.createRecord('0608c5a2', component.options)
    } else {
      api.reload('0608c5a2', component.options)
    }
    module.hot.accept("./GiantGemPkg.vue?vue&type=template&id=0608c5a2&", function () {
      api.rerender('0608c5a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/GiantGemPkg.vue"
export default component.exports